import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DconfigCoreSettings } from '../dconfig-core.settings';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContentsService {

  private websiteManagerUrlBase = DconfigCoreSettings.API_ENDPOINT + '/DConfig/WebsiteContentAPI';
  private formsUrlBase = DconfigCoreSettings.API_ENDPOINT + '/DConfig/FormsAPI';
  private membershipUrlBase = DconfigCoreSettings.API_ENDPOINT + '/Membership';

  constructor(private http: HttpClient) { }

  getContentsTree(id): Observable<Object> {
    if (id == undefined)
      return this.http.get(this.websiteManagerUrlBase + '/GetContentsTree');
    else
      return this.http.get(this.websiteManagerUrlBase +'/GetContentsTree/' + id);
  }

  getQuickContentList(id?): Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase +'/getquickcontentslist');
  }

  getContentsListsTree(id?): Observable<Object> {
    if (id == undefined)
      return this.http.get(this.websiteManagerUrlBase +'/getcontentslisttreeaction');
    else
      return this.http.get(this.websiteManagerUrlBase +'/getcontentslisttreeaction/' + id);
  }

  getContentChildren(id, limit, skip, keyword?): Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase +'/GetContentChildren/' + id + '?limit=' + limit + '&skip=' + skip + '&keyword=' + keyword);
  }

  getContentChildrenCount(id, keyword): Observable<Object>{
    return this.http.get(this.websiteManagerUrlBase +'/GetContentChildrenCount/' + id + '?keyword=' + keyword);
  }

  getContentInstances(id, boolean?): Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase +'/GetContentInstances/' + id);
  }

  getcontentinstancesForPrevVersions(id): Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase +'/GetContentInstancesForPrevVersions/' + id);
  }

  getcontentinstanceFieldsValues(id): Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase +'/getcontentinstanceFieldsValues/' + id);
  }

  getcontentByViewType(id, days): Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase + '/getContentsByViewType?Id=' + id + "&days=" + days);
  }

  getcontentByViewTypeByQuery(id, limit, skip, keyword?, days?, parentId?, keywordField?): Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase + '/getContentsByViewTypeByQuery?Id=' + id + '&limit=' + limit + '&skip=' + skip + '&keyword=' + keyword + "&days=" + days + "&parentId=" + parentId+ "&KeywordField=" + keywordField);
  }

  createContentNode(content, isContentVersion): Observable<Object> {
    if (isContentVersion)
      return this.http.post(this.websiteManagerUrlBase +'/CreateContentInstance', content);
    else
      return this.http.post(this.websiteManagerUrlBase +'/CreateContent', content);
  }

  cloneContentNode = function (id, isContentVersion, suffix): Observable<Object> {
    if (isContentVersion)
      return this.http.post(this.websiteManagerUrlBase +'/cloneContentInstance/' + id, { Suffix: suffix });
    else
      return this.http.post(this.websiteManagerUrlBase +'/cloneContent/' + id, { Suffix: suffix });
  }

  updateContentNode = function (content, typeOfNode): Observable<Object>{
    if (typeOfNode == "ContentVersion")
      return this.http.put(this.websiteManagerUrlBase +'/UpdateContentInstance', content);
    else
      return this.http.put(this.websiteManagerUrlBase +'/UpdateContent', content);
  }

  updateContentNodeParent = function (relationInfo, typeOfNode): Observable<Object> {
    if (typeOfNode == "ContentVersion")
      return this.http.put(this.websiteManagerUrlBase +'/UpdateContentInstanceParent', relationInfo);
    else
      return this.http.put(this.websiteManagerUrlBase +'/UpdateContentparent', relationInfo);
  }

  deleteContentNode = function (content, typeOfNode?): Observable<Object> {
    if (typeOfNode == "ContentVersion")
      return this.http.delete(this.websiteManagerUrlBase +'/DeleteContentInstance?Id=' + content.Id + "&Name=" + content.Name);
    else
      return this.http.delete(this.websiteManagerUrlBase +'/DeleteContent?Id=' + content.Id + "&Name=" + content.Name);
  }

  updateContentInstanceFieldValues = function (contentInstance): Observable<Object> {
    return this.http.put(this.websiteManagerUrlBase +'/UpdateContentInstanceFieldValues', contentInstance);
  }

  updateContentsOrdering = function (contents): Observable<Object> {
    return this.http.put(this.websiteManagerUrlBase +'/updateContentsOrdering', { Contents: contents });
  }

  addDomainToContent = function (content, domain): Observable<Object>  {
    return this.http.put(this.websiteManagerUrlBase +'/addDomainToContent/' + content.Id + '?Domain=' + domain, {});
  }

  removeDomainFromContent = function (content, domain): Observable<Object>  {
    return this.http.delete(this.websiteManagerUrlBase +'/removeDomainFromContent/' + content.Id + '?Domain=' + domain);
  }  

  updateViewTypeFields = function (type): Observable<Object>  {
    return this.http.put(this.websiteManagerUrlBase + '/updateViewTypeFields', type);
  }

  updateViewTypeChildren = function (viewType, ids): Observable<Object>  {
    return this.http.put(this.websiteManagerUrlBase + '/updateViewTypeChildren?Id=' + viewType.Id, ids);
  }

  getViewTypesTree = function () : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase + '/getViewTypesTree');
  }

  getViewFieldTypes = function () : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase + '/getViewFieldTypes');
  }

  createViewType = function (type) : Observable<Object> {
    return this.http.post(this.websiteManagerUrlBase + '/createViewType', type);
  }

  updateViewType = function (type) : Observable<Object> {
    return this.http.put(this.websiteManagerUrlBase + '/updateViewType', type);
  }

  deleteViewType = function (type) : Observable<Object> {
    return this.http.delete(this.websiteManagerUrlBase + '/deleteViewType?Id=' + type.Id + "&Name=" + type.Name);
  }

  getViewTypeChildren = function (viewType) : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase + '/getViewTypeChildren?Id=' + viewType.Id);
  }

  getViewFieldsEnumsTree = function () : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase +'/getViewFieldsEnumsTree');
  }

  getViewFieldsEnums = function () : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase +'/getViewFieldsEnums');
  }

  getViewFieldsEnumValuesById = function (id, limit, skip, keyword?, sortField?, sortOrder?): Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase + '/getViewFieldsEnumValuesById?Id=' + id + '&limit=' + limit + '&skip=' + skip + '&keyword=' + keyword + '&sortField=' + sortField + '&sortOrder=' + sortOrder);
  }

  getViewFieldsEnumValueById = function (id): Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase + '/getViewFieldsEnumValueById?Id=' + id);
  }

  createViewFieldsEnumValue = function (enumObj): Observable<Object> {
    return this.http.post(this.websiteManagerUrlBase + '/createViewFieldsEnumValue', enumObj);
  }

  updateViewFieldsEnumValue = function (enumObj): Observable<Object> {
    return this.http.put(this.websiteManagerUrlBase + '/updateViewFieldsEnumValue', enumObj);
  }

  createViewFieldsEnum = function (enumObj) : Observable<Object> {
    return this.http.post(this.websiteManagerUrlBase +'/createViewFieldsEnum', enumObj);
  }

  updateViewFieldsEnum = function (enumObj) : Observable<Object> {
    return this.http.put(this.websiteManagerUrlBase +'/updateViewFieldsEnum', enumObj);
  }

  deleteViewFieldsEnum = function (enumObj) : Observable<Object> {
    return this.http.delete(this.websiteManagerUrlBase +'/deleteViewFieldsEnum?Id=' + enumObj.Id + "&Name=" + enumObj.Name);
  }

  updateViewFieldsEnumValues = function (id, values) : Observable<Object> {
    return this.http.put(this.websiteManagerUrlBase +'/updateViewFieldsEnumValues?Id=' + id, values);
  }

  deleteViewFieldsEnumValue = function (id) : Observable<Object> {
    return this.http.delete(this.websiteManagerUrlBase +'/deleteViewFieldsEnumValue?Id=' + id);
  }

  deleteViewFieldsEnumValues = function (ids): Observable<Object> {
    return this.http.delete(this.websiteManagerUrlBase + '/deleteViewFieldsEnumValues', { Ids: ids });
  }

  getStages = function () : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase +'/getStages');
  }

  getStageRoles = function (stageId) : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase +'/getStageRoles?Id=' + stageId);
  }

  getStagesbyRole = function () : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase +'/getStagesbyRole');
  }

  createStage = function (stage) : Observable<Object> {
    return this.http.post(this.websiteManagerUrlBase +'/createStage', stage);
  }

  updateStage = function (stage) : Observable<Object> {
    return this.http.put(this.websiteManagerUrlBase +'/updateStage', stage);
  }

  deleteStage = function (stage) : Observable<Object> {
    return this.http.delete(this.websiteManagerUrlBase +'/deleteStage?Id=' + stage.Id + "&Name=" + stage.Name);
  }

  getNextStages = function (id?) : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase +'/getNextStages');
  }

  updateNextStages = function (stage, ids) : Observable<Object> {
    return this.http.put(this.websiteManagerUrlBase +'/updateNextStages?Id=' + stage.Id, { ids: ids });
  }

  stagingContentInstance = function (contentInstanceId, stageId, comments) : Observable<Object> {
    return this.http.put(this.websiteManagerUrlBase +'/stagingContentInstance?Id=' + stageId, { ContentId: contentInstanceId, Comments: comments });
  }

  getRoles = function () : Observable<Object> {
    return this.http.get(this.membershipUrlBase +'/getroles');
  }

  addStageToRole = function (stage, role) : Observable<Object> {
    return this.http.put(this.websiteManagerUrlBase +'/addStageToRole?Id=' + stage.Id, { RoleId: role.Id });
  }

  removeStageFromRole = function (stage, roleName) : Observable<Object> {
    return this.http.delete(this.websiteManagerUrlBase +'/removeStageFromRole?Id=' + stage.Id + "&RoleName=" + roleName);
  }

  ImportContentsFromExcel = function (ContentId, ExcelPath) : Observable<Object> {
    return this.http.post(this.websiteManagerUrlBase +'/importContentsFromExcel', { ContentId: ContentId, ExcelPath: ExcelPath });
  }

  ExportTemplateAsExcel = function (ContentId) : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase +'/exportTemplateExcel?ContentId=' + ContentId);
  }

  getViewTypes = function () : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase + '/getViewTypes');
  }

  getRootViewTypes = function () : Observable<Object> {
    return this.http.get(this.websiteManagerUrlBase + '/getRootViewTypes');
  }
}
